import React from "react";
import { RippleCircle } from "../../Styles/StyledScreens";

const AppRippleAnimation: React.FC = () => {
  return (
    <>
      <RippleCircle delay={0} />
      <RippleCircle delay={1.5} />
      <RippleCircle delay={2.5} />
    </>
  );
};

export default AppRippleAnimation; 